import React from 'react';
import SecurityIcon from '@ps-design-system/icons/Security/Security24';
import { FormattedMessage } from 'react-intl';
import { useStreamChatContext } from '../../utils/utils';

const defaultHostMessage = 'All messages are monitored; never transact outside of Peerspace to '
    + 'ensure you receive fraud protection, dispute resolution support, and property damage guarantee.';

const defaultGuestMessage = 'Never pay outside of Peerspace. Your booking is protected '
    + 'with secure payments, dedicated support, and comprehensive dispute resolution.';

const PaymentReminderHeader = () => {
  const { viewAs } = useStreamChatContext();
  const isHost = 'HOST' === viewAs;

  return (
    <div>
      <div className='PaymentReminderHeader'>
        <div className='icon-container'>
          <SecurityIcon color={'#6A6E7A'} height={24} width={24} className="security-icon"/>
        </div>
        <p className='reminder-text'>
          <FormattedMessage id={isHost ? 'inbox.payment_reminder.host' : 'inbox.payment_reminder.guest'}
            defaultMessage={isHost ? defaultHostMessage : defaultGuestMessage}/>
          {' '}
          {isHost
            && <a
              href="https://support.peerspace.com/hc/en-us/requests/new"
              target="_blank"
              className="underline reminder-text"
              rel="noreferrer"
            >
              <FormattedMessage id="inbox.disintermediation_modal.contact_support"
                defaultMessage="Learn more about Host coverage."/>
            </a>
          }
        </p>
      </div>
    </div>
  );
};

export default PaymentReminderHeader;
